import apiClient from "./axios"
import { downloadAndOpenFile } from "./pdfApi"

// Paginated/filtered list
export const getVehicleStockInventories = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stock-inventories", { params })
  return data
}

// Single
export const getVehicleStockInventory = async id => {
  const { data } = await apiClient.get(`/vehicle-stock-inventories/${id}`)
  return data
}

// Create
export const createVehicleStockInventory = async payload => {
  const { data } = await apiClient.post("/vehicle-stock-inventories", payload)
  return data
}

// Update
export const updateVehicleStockInventory = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(
    `/vehicle-stock-inventories/${id}`,
    payload
  )
  return data
}

// Soft delete
export const deleteVehicleStockInventory = async id => {
  const { data } = await apiClient.delete(`/vehicle-stock-inventories/${id}`)
  return data
}

// Trashed
export const getTrashedVehicleStockInventories = async (params = {}) => {
  const { data } = await apiClient.get("/vehicle-stock-inventories/trashed", {
    params,
  })
  return data
}

// Restore
export const restoreVehicleStockInventory = async id => {
  const { data } = await apiClient.post(
    `/vehicle-stock-inventories/${id}/restore`
  )
  return data
}

// Force delete
export const forceDeleteVehicleStockInventory = async id => {
  const { data } = await apiClient.delete(
    `/vehicle-stock-inventories/${id}/force-delete`
  )
  return data
}

// Download/open inventory PDF
export const getVehicleStockInventoryPdf = (id, setLoading) => {
  return downloadAndOpenFile({
    url: `/vehicle-stock-inventories/pdf/${id}`,
    mimeType: "application/pdf",
    openInNewTab: true,
    onStart: () => setLoading?.(true),
    onEnd: () => setLoading?.(false),
  })
}
